import { FetcherUptimeBucket, GetUptimeApiResponse } from 'multirpc-sdk';

export interface ChainUptimeResult {
  chainPath: string; // path
  overallUptimePercentage: number;
}

export const calculateChainUptime = (
  uptimeData: GetUptimeApiResponse,
): ChainUptimeResult[] => {
  return Object.entries(uptimeData).map(
    ([chainId, statuses]: [string, FetcherUptimeBucket[]]) => {
      const validStatuses = statuses.filter(
        (status: FetcherUptimeBucket) =>
          !status.no_data && status.uptime_percentage !== undefined,
      );

      const sumUptime = validStatuses.reduce(
        (acc: number, curr: FetcherUptimeBucket) =>
          acc + (curr.uptime_percentage || 0),
        0,
      );

      const overallUptimePercentage =
        validStatuses.length > 0 ? sumUptime / validStatuses.length : 0;

      return {
        chainPath: chainId,
        overallUptimePercentage,
      };
    },
  );
};
